import jQuery from 'jquery';
import { run } from './es/Site';

(function (document, window, $) {
  $(function () {
    Breakpoints();
    run();
  });
})(document, window, jQuery);
